// extracted by mini-css-extract-plugin
export default {"footerContainer":"CDaiYZhXKhB0vtcMPmGZ","buttons":"q93Uvqi6rMK_hRE25r_o","button":"jGzzRyGsLxGYyPlqx_Fd"};